import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
// import { DefaultService } from 'api/api';
// import { Product } from 'model/models';
import { urlencoded } from 'express';
import { AppService } from 'src/app/app.service';
import { ProductPageService, ProductService } from 'src/api/services';
import { ProductListResponseDataItem, ProductPage, ProductPageListResponseDataItem } from 'src/api/models';


@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  data: ProductListResponseDataItem;
  productPageData: ProductPageListResponseDataItem;
  id: string;


  constructor(
    private activateRoute: ActivatedRoute,
    public prodService: ProductService,
    public prodPageService: ProductPageService,
    public appService: AppService,
    private router: Router,
    public meta: Meta,
    public title: Title,
    private sanitizer: DomSanitizer
  ) {
    this.id = activateRoute.snapshot.params.id;

  }

  ngOnInit(): void {
    if (this.id) {
      const idAndArticle = decodeURIComponent(this.id).split('+');
      const id = Number(idAndArticle[0]);
      const article = idAndArticle[1];
      this.fillMainProduct(id, article);
      this.fillProductPageData();
    }
  }

  fillProductPageData() {
    this.prodPageService.getProductPage().subscribe(result => {
      this.productPageData = (result.data as ProductPageListResponseDataItem);
    });
  }

  fillMainProduct(id: number, article: string) {
    const params = { "filters": { "id": id }, "populate": "image, pdf, similar_products, similar_products.image, category, category.logo, Seo" };
    this.prodService.getProducts(params).subscribe(data => {
      this.data = data.data[0];
      if (this.data) {
        if (this.appService.indexData && this.appService.indexData.attributes.HeaderTitle) {
          const headerMeta = this.data.attributes.article + ' – ' +
            (this.data.attributes.manufacturer ? this.data.attributes.manufacturer + ' - ' : '') +
            (this.data.attributes.title ? this.data.attributes.title + ' - ' : '') +
            this.appService.indexData.attributes.HeaderTitle;
          const keywords = this.data.attributes.article + (this.data.attributes.title ? ', ' + this.data.attributes.title : '');

          this.meta = this.appService.setSEO(this.meta, keywords, headerMeta);
          this.title.setTitle(this.data.attributes.title);
        }
      }
      else {
        this.router.navigate(['/404']);
      }
    });
  }
}

